import {ApplicationState, ProposalResponse} from '@coc-kfz-digital/oma-rest-api-client';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { safeUnsubscribe } from 'src/app/shared/utils';
import { AbstractPageComponent } from '../abstract-page/abstract-page.component';
import LastPageEnum = ApplicationState.LastPageEnum;

export enum ProposalStatus {
  Loading = 'Loading',
  Success = 'Success',
  EvbPending = 'EvbPending',
  Fail = 'Fail',
  FailedCheck = 'FailedCheck'
}

@Component({
  selector: 'app-proposal-result-page',
  templateUrl: './proposal-result-page.component.html',
  styleUrls: ['./proposal-result-page.component.scss']
})
export class ProposalResultPageComponent extends AbstractPageComponent implements OnInit, OnDestroy {

  private proposalSubscription: Subscription;
  private proposalResponse: ProposalResponse = {};

  proposalStatus = ProposalStatus.Loading;

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.subscribeToProposal();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    safeUnsubscribe(this.proposalSubscription);
  }

  private subscribeToProposal() {
    const proposalObservable = this.carInsuranceProposalService.executeProposal();
    this.proposalSubscription = proposalObservable.subscribe(
      {
        next: (data: ProposalResponse) => this.refreshProposalData(data),
        error: () => this.proposalStatus = ProposalStatus.Fail,
      }
    );
  }

  private refreshProposalData(response: ProposalResponse) {
    this.proposalResponse = response;

    if (this.isAcceptedResponse(response)) {
      // OA-951: NAFI can accept the proposal (errorCode === 0) without returning an eVB.
      // Never show the eVB success page without an eVB number; the eVB is then
      // created and delivered manually by the back office.
      this.proposalStatus = this.hasEvbNumber(response)
        ? ProposalStatus.Success
        : ProposalStatus.EvbPending;
      this.authService.updateApplicationState(response.applicationState);
      this.carSaleCacheService.clear();
    } else if(response
      && response.applicationState.lastPage === LastPageEnum.CheckFailed)
    {
      this.proposalStatus = ProposalStatus.FailedCheck;
      this.authService.updateApplicationState(response.applicationState)
      this.carSaleCacheService.clear();
    } else {
      this.proposalStatus = ProposalStatus.Fail;
    }
  }

  /**
   * Returns if the proposal was accepted by checking the errorCode in the response.
   * (errorCode === 0) => accepted
   *
   * @param response the response to check
   */
  private isAcceptedResponse(response: ProposalResponse): boolean {
    return (response &&
      response.headerError &&
      response.headerError.errorCode === 0);
  }

  /**
   * Returns if the response contains a usable eVB number.
   *
   * @param response the response to check
   */
  private hasEvbNumber(response: ProposalResponse): boolean {
    return !!(response && response.eVBNumber && response.eVBNumber.trim().length > 0);
  }
}
